import { CommonSuccessResponse } from "constants/types/common";
import {
  DashboardParamsType,
  DashboardSummaryResponse,
} from "constants/types/dashboard";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const useDashboardSummary = (params: DashboardParamsType | null) => {
  const key = params ? `/dashboard/summary?${serialize(params)}` : null;
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<DashboardSummaryResponse> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(key, { refreshInterval: 0, revalidateOnFocus: false });

  return {
    dashboard: data?.data,
    error,
    isLoading,
    mutate,
  };
};
